import BaseService from "@/services/BaseService";

export default class CrudBaseService extends BaseService {
  constructor(serviceName) {
    super(serviceName);
  }

  findAll() {
    return this.http.get(this._serviceName);
  }

  get(id) {
    return this.http.get(`${this._serviceName}/${id}`);
  }

  save(data) {
    return this.http.post(this._serviceName, data);
  }

  update(id, data) {
    return this.http.put(`${this._serviceName}/${id}`, data);
  }

  delete(id) {
    return this.http.delete(`${this._serviceName}/${id}`);
  }
}
